module.exports = __webpack_public_path__ + "media/images/Panning for Gold-4f955124.jpg";